import { cn } from "@/lib/utils";

export function GridDivider({
  variant = 2,
  className,
  centerDotBlue,
  centerDotRef,
}: {
  variant?: 2 | 3;
  className?: string;
  centerDotBlue?: boolean;
  centerDotRef?: React.RefObject<HTMLDivElement | null>;
}) {
  return (
    <div
      className={cn(
        "relative z-[3] mx-0 flex h-[19px] items-center justify-center md:-mx-4 2xl:mx-0 2xl:gap-3",
        className,
      )}
    >
      {/* Left outer line */}
      <div className="bg-ds-border h-px min-w-0 flex-1 md:min-w-4" />
      {/* Inner content area with circles and line segments */}
      <div className="flex w-full max-w-[1440px] items-center lg:gap-2">
        <div className="bg-ds-surface-primary hidden shrink-0 py-2 lg:block">
          <div className="bg-ds-surface-primary shadow-ds-white-pressed size-[19px] rounded-full" />
        </div>
        {variant === 3 ? (
          <>
            <div className="bg-ds-neutral-200 hidden h-px min-w-0 flex-1 lg:block" />
            <div
              ref={centerDotRef}
              className={cn(
                "hidden size-[18px] shrink-0 rounded-full lg:block",
                centerDotBlue
                  ? "bg-ds-brand-500 shadow-[0_0_8px_rgba(47,67,255,0.4)]"
                  : "bg-ds-surface-primary shadow-ds-white-pressed",
              )}
            />
          </>
        ) : null}
        <div className="bg-ds-border h-px min-w-0 flex-1" />
        <div className="bg-ds-surface-primary hidden shrink-0 py-2 lg:block">
          <div className="bg-ds-surface-primary shadow-ds-white-pressed size-[19px] rounded-full" />
        </div>
      </div>
      {/* Right outer line */}
      <div className="bg-ds-border h-px min-w-0 flex-1 md:min-w-4" />
    </div>
  );
}

export function GridBorderedSection({ children, className }: { children?: React.ReactNode; className?: string }) {
  return (
    <div className={`relative ${className ?? ""}`}>
      <div
        className="pointer-events-none absolute inset-0 z-[1] flex justify-center overflow-hidden"
        aria-hidden="true"
      >
        <div className="w-full max-w-[1440px] px-[9px]">
          <div className="border-ds-border h-full lg:border-l lg:border-r" />
        </div>
      </div>
      {children}
    </div>
  );
}
